import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Form,
  Tag,
  Input,
  Select,
  Row,
  Col,
  message,
} from "antd";
import React, { useState } from "react";
import { collection, doc, updateDoc } from "firebase/firestore";
import dayjs from "dayjs";
import { db } from "../../../../firebase";
import { DynamicPhone } from "../../../../components/DynamicPhone";

const PropertyInformation = ({ data, dataId, isUpdate,companyName }) => {
  const [isEditActive, setIsEditActive] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);

  const { TextArea } = Input;

  const dateFormat = "YYYY/MM/DD";
  const yearFormat = "YYYY";

  const initialValues = {
    readyForShowingOn: data?.readyForShowingOn
      ? dayjs(data?.readyForShowingOn, dateFormat)
      : "",
    rentReady: data?.rentReady,
    description: data?.description || "",
    portfolio: data?.portfolio || "",
    taxAuthority: data?.taxAuthority || "",
    managerSalutation: data?.managerSalutation || "",
    managerFirstName: data?.siteManagerFirstName || "",
    managerLastName: data?.siteManagerLastName || "",
    managerPhoneNumber: data?.managerPhoneNumber || "",
    yearBuilt: data?.yearBuilt ? dayjs(data?.yearBuilt, yearFormat) : "",
    managementStartDate: data?.managementStartDate
      ? dayjs(data?.managementStartDate, dateFormat)
      : "",
    managementEndDate: data?.managementEndDate
      ? dayjs(data?.managementEndDate, dateFormat)
      : "",
    managementEndReason: data?.managementEndReason || "",
    liabilitytoLandlordInsurance: data?.liabilityLandlordInsurance || "",
    folioGuardPolicyAdditionalInterest:
      data?.folioGuardPolicyAdditionalInterest || false,
    interestedParty: data?.interestedParty || "",
    contactEmail: data?.contactEmail || "",
    tags: data?.tags || [],
    // Add other fields and their initial values here
  };

  const onFinish = (fieldsValue) => {
    const values = {
      ...fieldsValue,
      managementStartDate: fieldsValue["managementStartDate"]
        ? fieldsValue["managementStartDate"].format("YYYY-MM-DD")
        : null,
      managementEndDate: fieldsValue["managementEndDate"]
        ? fieldsValue["managementEndDate"].format("YYYY-MM-DD")
        : null,
      readyForShowingOn: fieldsValue["readyForShowingOn"]
        ? fieldsValue["readyForShowingOn"].format("YYYY-MM-DD")
        : null,
      yearBuilt: fieldsValue["yearBuilt"]
        ? fieldsValue["yearBuilt"].format("YYYY")
        : null,
    };
    console.log("Success:", values);

    isUpdate(true);
    setIsWaiting(true);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);
      updateDoc(propertyDocRef, {
        "propertyInformation.readyForShowingOn": values.readyForShowingOn || "",
        "propertyInformation.rentReady": values.rentReady || "",
        "propertyInformation.description": values.description || "",
        "propertyInformation.portfolio": values.portfolio || "",
        "propertyInformation.taxAuthority": values.taxAuthority || "",
        "propertyInformation.managerSalutation": values.managerSalutation || "",
        "propertyInformation.managerFirstName": values.managerFirstName || "",
        "propertyInformation.managerLastName": values.managerLastName || "",
        "propertyInformation.managerPhoneNumber": values.managerPhoneNumber || "",
        "propertyInformation.yearBuilt": values.yearBuilt || "",
        "propertyInformation.managementStartDate": values.managementStartDate || "",
        "propertyInformation.managementEndDate": values.managementEndDate || "",
        "propertyInformation.managementEndReason": values.managementEndReason || "",
        "propertyInformation.liabilitytoLandlordInsurance":
          values.liabilitytoLandlordInsurance || "",
        "propertyInformation.folioGuardPolicyAdditionalInterest":
          values.folioGuardPolicyAdditionalInterest || "",
        "propertyInformation.interestedParty": values.interestedParty || "",
        "propertyInformation.contactEmail": values.contactEmail || "",
        "propertyInformation.tags": values.tags || [],
      });

      setTimeout(() => {
        setIsEditActive(false);
        setIsWaiting(false);
      }, 3000);
      message.success("Property Information Data Updated Successfully", 3);
    } catch (error) {
      console.log("Error updating Properties data:", error);
      message.error("Failed to update Properties Information data.", 3);

      setIsWaiting(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setIsWaiting(false);
  };
  const [form] = Form.useForm();
  return (
    <div>
      <Card
        title="Property Information"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
                setIsWaiting(false);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          form={form}
          autoComplete="off"
          colon={false}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item label="Status">
            <p>Vacant</p>
          </Form.Item>

          <Form.Item
            label="Rent Ready"
            name="rentReady"
            valuePropName="checked"
          >
            {isEditActive ? (
              <Checkbox></Checkbox>
            ) : (
              <>{data?.rentReady ? "Yes" : "No"}</>
            )}
          </Form.Item>
          <Form.Item label="Ready For Showing On" name="readyForShowingOn">
            {isEditActive ? (
              <DatePicker format={dateFormat} style={{ width: "100%" }} />
            ) : (
              <p>
                {data?.readyForreadyForShowingOn === ""
                  ? "--"
                  : data?.readyForShowingOn}
              </p>
            )}
          </Form.Item>
          {!isEditActive && (
            <Form.Item label="Lockbox">
              <a href="#">test</a>
            </Form.Item>
          )}
          <Form.Item label="Description" name="description">
            {isEditActive ? (
              <TextArea
                style={{
                  height: 120,
                  resize: "none",
                }}
              />
            ) : (
              <p>{data?.description === "" ? "--" : data?.description}</p>
            )}
          </Form.Item>
          <Form.Item label="Portfolio" name="portfolio">
            {isEditActive ? (
              <Input disabled />
            ) : (
              <p>{data?.portfolio === "" ? "--" : data?.portfolio}</p>
            )}
          </Form.Item>
          <Form.Item label="Tax Authority" name="taxAuthority">
            {isEditActive ? (
              <Select
                showSearch
                placeholder="Begin typing to search"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "test",
                    label: "test",
                  },
                  {
                    value: "test2",
                    label: "test2",
                  },
                  {
                    value: "test3",
                    label: "test3",
                  },
                ]}
              />
            ) : (
              <p>{data?.taxAuthority === "" ? "--" : data?.taxAuthority}</p>
            )}
          </Form.Item>
          <Form.Item label="Site Manager">
            {isEditActive ? (
              <>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item name="managerSalutation">
                      <Select
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={[
                          {
                            value: "Dr.",
                          },
                          {
                            value: "Mr.",
                          },
                          {
                            value: "Mr. & Mrs.",
                          },
                          {
                            value: "Mrs.",
                          },
                          {
                            value: "Ms.",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label=" " name="managerFirstName">
                      <Input placeholder="First Name" />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label=" " name="managerLastName">
                      <Input placeholder="Last Name" />
                    </Form.Item>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col span={24}>
                    <Form.Item label=" " name="managerPhoneNumber">
                      <DynamicPhone />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            ) : (
              <p>
                {data?.managerSalutation} {data?.siteManagerFirstName}{" "}
                {data?.siteManagerLastName} <br />
                {data?.managerPhoneNumber}
              </p>
            )}
          </Form.Item>
          <Form.Item label="Year Built" name="yearBuilt">
            {isEditActive ? (
              <DatePicker picker="year" format={yearFormat} />
            ) : (
              <p>{data?.yearBuilt === "" ? "--" : data?.yearBuilt}</p>
            )}
          </Form.Item>
          <Form.Item label="Management Start Date" name="managementStartDate">
            {isEditActive ? (
              <DatePicker format={dateFormat} style={{ width: "100%" }} />
            ) : (
              <p>
                {data?.managementStartDate === ""
                  ? "--"
                  : data?.managementStartDate}
              </p>
            )}
          </Form.Item>
          <Form.Item label="Management End Date" name="managementEndDate">
            {isEditActive ? (
              <DatePicker format={dateFormat} style={{ width: "100%" }} />
            ) : (
              <p>
                {data?.managementEndDate === ""
                  ? "--"
                  : data?.managementEndDate}
              </p>
            )}
          </Form.Item>
          <Form.Item label="Management End Reason" name="managementEndReason">
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "Foreclosure",
                  },
                  {
                    value: "Maintenance",
                  },
                  {
                    value: "Management Company Concerns",
                  },
                  {
                    value: "Management Company Terminated",
                  },
                  {
                    value: "Owner Moved In",
                  },
                ]}
              />
            ) : (
              <p>
                {data?.managementEndReason === ""
                  ? "--"
                  : data?.managementEndReason}
              </p>
            )}
          </Form.Item>
          <Form.Item
            label="Liability to Landlord Insurance "
            name="liabilitytoLandlordInsurance"
          >
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "On",
                  },
                  {
                    value: "Off",
                  },
                ]}
              />
            ) : (
              <p>
                {data?.liabilityLandlordInsurance === ""
                  ? "--"
                  : data?.liabilityLandlordInsurance}
              </p>
            )}
          </Form.Item>
          <Form.Item
            label="FolioGuard Policy Additional Interest"
            name="folioGuardPolicyAdditionalInterest"
            valuePropName="checked"
          >
            {isEditActive ? (
              <Checkbox></Checkbox>
            ) : (
              <p>{data?.folioGuardPolicyAdditionalInterest ? "Yes" : "No"}</p>
            )}
          </Form.Item>
          <Form.Item label="Interested Party" name="interestedParty">
            {isEditActive ? (
              <Input disabled />
            ) : (
              <p>
                {data?.interestedParty === "" ? "--" : data?.interestedParty}
              </p>
            )}
          </Form.Item>
          <Form.Item label="Contact Email" name="contactEmail">
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "t t | View Only | rltullis@gmail.com",
                  },
                  {
                    value:
                      "Chris Loney | Property Manager | chris@integrityokc.com",
                  },
                  {
                    value:
                      "Rex Tullis | Property Manager | rex@integrityokc.com",
                  },
                ]}
              />
            ) : (
              <p>{data?.contactEmail === "" ? "--" : data?.contactEmail}</p>
            )}
          </Form.Item>

          <Form.Item
            label="Tags"
            name="tags"
            extra={isEditActive && <a href="#">Manage Tags</a>}
          >
            {isEditActive ? (
              <Select
                mode="tags"
                allowClear
                style={{
                  width: "100%",
                }}
                options={[
                  { value: "test1" },
                  { value: "test2" },
                  { value: "test3" },
                  { value: "test4" },
                  { value: "test5" },
                ]}
                tokenSeparators={[","]}
              />
            ) : (
              <>
                {data?.tags?.length > 0
                  ? data?.tags.map((tag) => <Tag key={tag}>{tag}</Tag>)
                  : "--"}
              </>
            )}
          </Form.Item>
          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isWaiting}>
                  {isWaiting ? "Please wait..." : "Save"}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default PropertyInformation;
